export default "__VITE_ASSET__CqaS9_j4__"